import Link from 'next/link';
import React, { FC, ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface RequiresLoginProps {
  children: ReactNode;
  dimmed: boolean;
}

const RequiresLogin: FC<RequiresLoginProps> = ({ children, dimmed }) => (
  <div 
    className={cn(
      "relative block",
      dimmed ? "h-16" : "h-full"
    )}
  >
    <div className={cn(
      dimmed && "blur-sm pointer-events-none"
    )}>
      {children}
    </div>
    {dimmed && (
      <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
        <Link href="/login" className="text-white hover:text-gray-200">
          <h3 className="text-xl font-semibold">
            登入後觀看
          </h3>
        </Link>
      </div>
    )}
  </div>
);

export default RequiresLogin;